/**
 * App Layout Component
 * Main layout wrapper with header and bottom navigation
 */

import { Header } from './Header';
import { BottomNav, type Page } from './BottomNav';
import { useUIStore } from '../../store/uiStore';

interface AppLayoutProps {
  children: React.ReactNode;
  currentPage: Page;
  onNavigate: (page: Page) => void;
  title?: string;
  showHeader?: boolean;
  showNav?: boolean;
}

export function AppLayout({
  children,
  currentPage,
  onNavigate,
  title,
  showHeader = true,
  showNav = true,
}: AppLayoutProps) {
  const { theme } = useUIStore();
  const isLight = theme === 'light';

  return (
    <div className={`min-h-screen flex flex-col transition-colors duration-200 ${
      isLight ? 'bg-slate-50' : 'bg-slate-950'
    }`}>
      {showHeader && <Header title={title} currentPage={currentPage} />}

      <main className={`flex-1 ${showNav ? 'pb-20' : ''}`}>
        <div className="max-w-lg mx-auto">
          {children}
        </div>
      </main>

      {showNav && <BottomNav currentPage={currentPage} onNavigate={onNavigate} />}
    </div>
  );
}
